import { useQuery } from '@tanstack/react-query'
import { hrDashboard } from '../../api/hr/dashboard'
import { dashboard } from '../../api/payroll/dashboard'
import { spendDashboard } from '../../api/spend/dashboard'

export function useGetDashboard() {
  return useQuery(['dashboard'], () => {
    return dashboard.getDashboard()
  })
}

export function useGetHRDashboard() {
  return useQuery(['hr-dashboard'], () => {
    return hrDashboard.getDashboard()
  })
}

export function useGetEmployeesReport(dateRange) {
  return useQuery(
    ['employees-report', dateRange],
    () => {
      return hrDashboard.getEmployeesReport(dateRange)
    },
    { enabled: !!dateRange }
  )
}

export function useGetMoneyInflow(start_date, end_date) {
  return useQuery(
    ['money-inflow', { start_date, end_date }],
    () => {
      return hrDashboard.getMoneyInflow({ start_date, end_date })
    },
    { enabled: !!start_date && !!end_date }
  )
}

export function useGetSpendDashboard() {
  return useQuery(
    ['spend-dashboard'],
    () => {
      return spendDashboard.getDashboard()
    },
  )

}
